<div class="w-full">
  <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
    <div class="flex items-center">
      <h6 mat-dialog-title class="font-semibold primary-font">{{dialogData.dialogTitle | translate}}</h6>
    </div>
    <div class="flex items-center mr-1">
      <span mat-dialog-close class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
  </div>
  <div class="flex flex-col zuper-dialog-body">
    <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start pb-6 sm:pb-8">

      <!-- Icon -->
      <ng-container>
          <div
              class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600">
              <mat-icon
                  class="text-current"
                  svgIcon="heroicons_outline:exclamation"></mat-icon>
          </div>
      </ng-container>

      <ng-container>
          <div class="flex flex-col items-center justify-center sm:items-start sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">
              <!-- Message -->
              <ng-container *ngIf="dialogData?.message">
                  <div
                      class="mt-2" 
                      [innerHTML]="dialogData?.message"></div>
              </ng-container>
          </div>
      </ng-container>

    </div>
    
  </div>
  <div class="flex border-t border-gray-300 zuper-dialog-footer" [ngClass]="dialogData?.isRecurrence ? 'justify-between' : 'justify-end'">
    <div *ngIf="dialogData?.isRecurrence" class="flex items-center">
      <form [formGroup]="updateAllRecurringJobForm" class="cancelForm h-full overflow-y-none" autocomplete="off">
        <div class="w-full flex items-center space-x-2">
          <input
              type="checkbox"
              id="reason" formControlName="update_all_jobs"/>
              <span>{{'delete.line.item.recuurent.job.message' | translate}}</span>
        </div>
      </form>
    </div>
    <div class="flex justify-around space-x-4 bg-gray-50">
        <button type="button" mat-stroked-button mat-dialog-close class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text' | translate}}</button>
        <button (click)="submit()" class="min-w-24 px-6 btn-small items-center py-2 border b-1 shadow-sm text-base text-white font-medium rounded-md text-white-600 focus:outline-none bg-red-600">
          <span>{{'text.remove' | translate}}</span>
        </button>
    </div>
  </div>
</div> 